import Vue from "vue";

export async function fetchWeather({ commit }, user_id){
  try {
    const { data } = await Vue.axios({
      url: `/frontend/weather?id=${user_id}`
    });
    commit("weather/setWeather", data, { root: true });
  } catch (e) {
    commit("weatherError", e.message);
  } finally {
    // console.log("La petición para obtener el clima ha finalizado");
  }
}
